import type { KeyTextField, LinkField, RichTextField } from '@prismicio/client';
import { PrismicRichText, type JSXMapSerializer } from '@prismicio/react';

import styles from './loanUsesContent.module.scss';
import { Button } from '@/components';

interface LoanUsesContextProps {
  title: RichTextField;
  subtitle: KeyTextField;
  button: {
    text: KeyTextField;
    link: LinkField;
  };
  isVisible: boolean;
}

const components: JSXMapSerializer = {
  heading2: ({ children }) => <h2 className={styles.title}>{children}</h2>,
};

export const LoanUsesContent = ({
  button,
  subtitle,
  title,
  isVisible,
}: LoanUsesContextProps) => {
  const isVisibleStyles = isVisible ? styles.isVisible : '';
  return (
    <div className={styles.context}>
      <div className={`${styles.title_wrapper} ${isVisibleStyles}`}>
        <PrismicRichText field={title} components={components} />
      </div>
      <p className={`${styles.subtitle} ${isVisibleStyles}`}>{subtitle}</p>
      <div className={`${styles.button_wrapper} ${isVisibleStyles}`}>
        <Button link={button.link} text={button.text} variation="transparent" />
      </div>
    </div>
  );
};
